import React from 'react';

import { alpha } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  row: {
    alignItems: 'flex-start',
    display: 'grid',
    gridGap: theme.spacing(1.5),
    gridTemplateColumns: ({ hasAction }) =>
      `minmax(0, 1fr) auto minmax(0, 1.4fr)${hasAction ? ' auto' : ''}`,
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' },
  },
  arrow: {
    alignItems: 'center',
    color: theme.palette.text.disabled,
    display: 'flex',
    height: ({ dense }) => (dense ? 40 : 56),
    [theme.breakpoints.down('xs')]: { display: 'none' },
  },
  action: {
    alignItems: 'center',
    display: 'flex',
    height: ({ dense }) => (dense ? 40 : 56),
  },
  selling: {
    '& .MuiOutlinedInput-root': { backgroundColor: alpha(theme.palette.primary.main, 0.04) },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '& .Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.error.main },
    '& .MuiInputBase-input': {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
    '& .MuiInputLabel-root:not(.Mui-error)': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
}));

function PriceFields({ listField, sellingField, action, dense }) {
  // Hooks
  const classes = useStyles({ hasAction: !!action, dense });

  return (
    <div className={classes.row}>
      <div>{listField}</div>
      <div className={classes.arrow}>
        <Mui.Icon fontSize="small">arrow_forward</Mui.Icon>
      </div>
      <div className={classes.selling}>{sellingField}</div>
      {!!action && <div className={classes.action}>{action}</div>}
    </div>
  );
}

PriceFields.propTypes = {
  listField: PropTypes.node.isRequired,
  sellingField: PropTypes.node.isRequired,
  action: PropTypes.node,
  dense: PropTypes.bool,
};

export default PriceFields;
